import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import BaseButtonIcon from "../ui-library/base-button/base-button-icon.vue";
import VisibilityIcon from "@/ui-library/icons/visibility-icon.vue";
import VisibilityOffIcon from "@/ui-library/icons/visibility-off-icon.vue";
import BaseTooltip from "../ui-library/base-tooltip/base-tooltip.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'password-visibility-toggle-button',
  props: {
    isPasswordVisible: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseButtonIcon, {
    class: "password-visibility-button",
    tertiary: "",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('togglePasswordVisibility')))
  }, {
    default: _withCtx(() => [
      _createVNode(BaseTooltip, { location: "bottom left" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(__props.isPasswordVisible ? "Hide password" : "Reveal password"), 1)
        ]),
        _: 1
      }),
      (__props.isPasswordVisible)
        ? (_openBlock(), _createBlock(VisibilityIcon, {
            key: 0,
            class: "visibility-icon"
          }))
        : _createCommentVNode("", true),
      (!__props.isPasswordVisible)
        ? (_openBlock(), _createBlock(VisibilityOffIcon, { key: 1 }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})